import { useTranslation } from 'react-i18next'
import { DataItem } from 'scrivito'

import { StringText } from '@/Atomic/Atoms/StringText'
import InfoBox from '@/Atomic/Molecules/InfoBox'
import { Modal } from '@/Atomic/Organisms/Modal'
import { useDocumentContext } from '@/hooks/documents/useDocumentHandler'

import './UnlinkDocumentModal.scss'

export interface UnlinkDocumentModalProps {
  isOpen: boolean
  close: () => void
  document: DataItem
}

export const UnlinkDocumentModal: React.FC<UnlinkDocumentModalProps> = ({
  isOpen,
  close,
  document,
}) => {
  const { t } = useTranslation()
  const { deleteRelation } = useDocumentContext()
  const title = (document.get('title') as string) || ''
  const documentId = document.id()

  const handleUnlink = async () => {
    deleteRelation(documentId).then(() => {
      close()
    })
  }

  const handleCancel = () => {
    close()
  }

  return (
    <Modal onClose={handleCancel} isOpen={isOpen}>
      <Modal.Header title={t('common.unlink')} />
      <Modal.Body className="unlink-modal-body">
        <StringText value={t('components.document.unlinkFileFor', { title })} />
        <InfoBox text={t('components.document.unlinkFileSavely')} />
      </Modal.Body>
      <Modal.Footer
        onCancel={handleCancel}
        onCancelText={t('common.cancel')}
        onConfirm={handleUnlink}
        onConfirmText={t('common.unlink')}
      />
    </Modal>
  )
}
